define('modules/editor/index',['require','exports','module','common/models/appstate','./views/main','./models/variant','modules/form_editor/index','./services/text_content/index','./services/popup_content/index','./services/video_content/index','modules/includes_editor/index','./services/image_upload/index','modules/page_generator/service','./services/seo/index','./services/copy_paste/index','./services/integrations/index'],function(require, exports, module) {
  "use strict";

  var AppState = require("common/models/appstate"),
      EditorView = require("./views/main"),
      //Page = require("./models/page"),
      Variant = require("./models/variant"),
      //services
      FormEditorService = require("modules/form_editor/index"),
      TextContentService = require("./services/text_content/index"),
      PopupContentService = require("./services/popup_content/index"),
      VideoContentService = require("./services/video_content/index"),
      IncludeContentService = require("modules/includes_editor/index"),
      ImageUploadService = require("./services/image_upload/index"),
      PageGeneratorService = require("modules/page_generator/service"),
      SeoService = require("./services/seo/index"),
      CopyPasteService = require("./services/copy_paste/index"),
      IntegrationsService = require("./services/integrations/index");

  return function(options) {
    // instantiate or recreate the variant
    var variant = new Variant({pages_id: parseInt(options.pageId), id: options.variantId}),
        editorView = new EditorView(_.extend(options, {model: variant, noBinding:true}));
    //TODO: when API is ready

    //set up services that need something from the editor layout
    TextContentService.editor = editorView;
    VideoContentService.editor = editorView;
    SeoService.editor = editorView;
    PopupContentService.editor = editorView;

    // registering content providers and external services
    variant.services.registerHandlers({
      "text:content": {
        context: TextContentService,
        callback: TextContentService.editText
      },
      //video content
      "video:content": {
        context: VideoContentService,
        callback: VideoContentService.editVideo
      },
      //popup content
      "popup:content": {
        context: PopupContentService,
        callback: PopupContentService.editPopup
      }
    });

    //form editor service
    FormEditorService.editor = editorView;
    variant.services.registerHandlers({
      "form:content": {
        context: FormEditorService,
        callback: FormEditorService.editForm
      }
    });

    //include services
    IncludeContentService.editor = editorView;
    variant.services.registerHandlers({
      "styles:content": {
        context: IncludeContentService,
        callback: IncludeContentService.editStyles
      },
      "scripts:content": {
        context: IncludeContentService,
        callback: IncludeContentService.editScripts
      }
    });

    //image upload service
    ImageUploadService.editor = editorView;
    ImageUploadService.pageId = parseInt(options.pageId);
    //get variantId when it's loaded
    editorView.on("variant:ready", _.bind(function(model){
      ImageUploadService.variantId = model.id;
      ImageUploadService.platform = model.get("platform");
    }, this));
    variant.services.registerHandlers({
      "image:content": {
        context: ImageUploadService,
        callback: ImageUploadService.loadImage
      }
    });

    //page generator service
    variant.services.registerHandlers({
      "page:render": {
        context: PageGeneratorService,
        callback: PageGeneratorService.generatePage
      }
    });
    variant.services.registerHandlers({
      "page:preview": {
        context: PageGeneratorService,
        callback: function() { PageGeneratorService.showPreviewFromModel(options); }
      }
    });

    //SEO service
    variant.services.registerHandlers({
      "seo:content": {
        context: SeoService,
        callback: SeoService.editSEO
      }
    });

    //copyPaste service
    variant.services.registerHandlers({
      "copyPaste:copy": {
        context: CopyPasteService,
        callback: CopyPasteService.copy
      }
    });

    variant.services.registerHandlers({
      "copyPaste:paste": {
        context: CopyPasteService,
        callback: CopyPasteService.paste
      }
    });

    //Integration status service
    variant.services.registerHandlers({
      "integration:status": {
        context: IntegrationsService,
        callback: IntegrationsService.getIntegrations
      }
    });
    editorView.on("variant:ready", IntegrationsService.fetchStatus);

    //THIS IS NEEDED FOR LIVE PREVIEW FROM EDITOR
    window.MVariant = variant;

    // let's go!
    return editorView;
  };
});

